import '../../assets/components/Modal/Modal.css';//#region lib/components/Modal/Modal.module.css
var e = "_layer_gcevi_1", t = "_overlay_gcevi_6", n = "_content_gcevi_13", r = "_card_gcevi_34", i = "_header_gcevi_41", a = "_headerLeft_gcevi_49", o = "_headerIcon_gcevi_58", s = "_headerTitle_gcevi_65", c = "_closeButtonWrapper_gcevi_69", l = "_scrollableBody_gcevi_74", u = "_footer_gcevi_80", d = "_visuallyHidden_gcevi_89", f = {
	layer: e,
	overlay: t,
	content: n,
	card: r,
	header: i,
	headerLeft: a,
	headerIcon: o,
	headerTitle: s,
	closeButtonWrapper: c,
	scrollableBody: l,
	footer: u,
	visuallyHidden: d
};
//#endregion
export { r as card, c as closeButtonWrapper, n as content, f as default, u as footer, i as header, o as headerIcon, a as headerLeft, s as headerTitle, e as layer, t as overlay, l as scrollableBody, d as visuallyHidden };
